import React, { useState, useEffect, useRef } from "react";
import { theme } from "../../../index";
import RenderSingleTestSeriesListingRow from "./RenderSingleTestSeriesListingRow";
import { Shimmer } from "react-shimmer";
import ClipLoader from "react-spinners/ClipLoader";
import Snackbar from "@material-ui/core/Snackbar";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { dataLimit } from "../../..";
import Select from "react-select";
import {
  add_institute_testSeries,
  editTestSeries,
  fetch_all_interns,
  fetch_testSeries_by_subCategory,
} from "../../../api/testSeries/testseries";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { s3upload } from "../../../api/aws";
const TestSeriesListing = (props) => {
  const location = useLocation();

  const [offset, setOffset] = useState(0);
  const [showShimmer, setShowShimmer] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [loadingAddSeries, setLoadingAddSeries] = useState(false);
  const [isSnackBarShow, setIsSnackBarShow] = useState(false);
  const [isLast, setIsLast] = useState(false);
  const [isSectionTimeShared, setIsSectionTimeShared] = useState();
  const [SnackBarMessage, setSnackBarMessage] = useState("");
  const [mode, setMode] = useState("");
  const [languages, setLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState();
  const [duration, setDuration] = useState("");
  const [title, setTitle] = useState("");
  const [testSeriesData, setTestSeriesData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [addSeriesData, setAddSeriesData] = useState({
    languages: ["English"],
  });
  const [modalMode, setModalMode] = useState("");
  const [allInterns, setAllInterns] = useState([]);
  const [docFile, setDocFile] = useState();
  let fileRef = useRef(null);
  const { subCatId, subCatName, catId, catName } = useParams();
  const history = useHistory();
  const languageOptionList = [
    { value: "Hindi", label: "Hindi" },
    { value: "English", label: "English" },
  ];
  const deleteCallback = (response, index) => {
    if (response.status === 200) {
      const arr = [...testSeriesData];
      arr.splice(index, 1);
      setTestSeriesData(arr);
    }
  };

  const addTestSeriesCallback = (response) => {
    if (response.status === 200) {
      response.json().then((data) => {
        console.log("res", data)
        setTestSeriesData([...testSeriesData, { ...addSeriesData, id: data.data.id }])
        setAddSeriesData({});
        setLoadingAddSeries(false);
      });
      setIsAddModalVisible(false);
    }

    setLoadingAddSeries(false);
    setIsAddModalVisible(false);
    setLanguages([]);
    setSelectedLanguages([]);
  };

  const addTestSeriesData = async () => {
    setLoadingAddSeries(true);
    // selectedLanguages.map((val, i) => {
    //     languages.push(val.value)
    // })
    let documentObj = null;
    if (docFile) {
      documentObj = await s3upload(
        docFile,
        () => { },
        `testSeries/${catId}_${catName}/${subCatId}_${subCatName}/${addSeriesData["title"]}/`
      );
    }

    addSeriesData["languages"] = ["English"];
    addSeriesData["testSeriesExamTestTypeSubCategory"] = { id: subCatId };
    addSeriesData["status"] = "UNPUBLISHED";

    if (addSeriesData["scheduledReleaseDateTime"]?.length > 0) {
      addSeriesData["scheduledReleaseDateTime"] =
        addSeriesData["scheduledReleaseDateTime"] + ":00";
    } else {
      addSeriesData["scheduledReleaseDateTime"] = "";
    }

    addSeriesData["responseSheetUrl"] = documentObj?.filePath; // Fixed syntax here
    add_institute_testSeries(addSeriesData, addTestSeriesCallback);

    setLoadingAddSeries(false);
    setIsAddModalVisible(false);
  };
  const closeSnack = () => {
    setIsSnackBarShow(false);
  };
  const fetchCallback = (response) => {
    if (response.status === 200) {
      response.json().then((data) => {
        setTestSeriesData(data?.data?.rows);
        setIsLast(data.last);
      });

      setShowLoader(false);
    }
  };
  useEffect(() => {
    setShowLoader(true);
    fetch_testSeries_by_subCategory(subCatId, offset, dataLimit, fetchCallback);
  }, [offset]);

  function handleLanguageSelect(data) {
    setSelectedLanguages(data);
  }

  const handleInputChange = (e) => {
    const obj = { ...addSeriesData };
    obj[e.target.name] = e.target.value;
    setAddSeriesData(obj);
  };

  const updateTestSeriesAtIndex = (data, index) => {
    const testArr = [...testSeriesData];
    testArr[index] = data;
    setTestSeriesData(testArr);
  };

  const fetchAllInterns = async () => {
    const response = await fetch_all_interns();

    setAllInterns(
      response.data?.map((item) => ({ name: item.name, id: item.id }))
    );
  };

  useEffect(() => {
    fetchAllInterns();
  }, []);

  const fileOnChange = (event) => {
    var url = event.target.files[0]
      ? URL.createObjectURL(event.target.files[0])
      : "";
    setDocFile(event.target.files[0]);
  };

  return (
    <div>
      <div class="page-breadcrumb  d-md-flex align-items-center mb-3">
        <div class="breadcrumb-title pr-3">Test Series</div>
        <div class="pl-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
              <li class="breadcrumb-item">
                <a href="javascript:;">
                  <i class="bx bx-home-alt"></i>
                </a>
              </li>
            </ol>
          </nav>
        </div>
        <div class="ml-auto">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-danger"
              style={{ marginRight: 5 }}
              onClick={() => {
                setIsAddModalVisible(true);
                setAddSeriesData({});
              }}
            >
              Add
            </button>
          </div>
          <button
            type="button"
            class="btn btn-dark"
            onClick={() => history.goBack()}
          >
            Go Back
          </button>
        </div>
      </div>

      {showLoader ? (
        <Shimmer width={"100%"} height={40} />
      ) : (
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table
                class="table table-striped table-bordered mb-0"
                id="table1"
              >
                <thead class="thead-dark">
                  <tr>
                    <th align="center">#</th>
                    <th align="center">Id</th>
                    <th align="center">Title</th>
                    <th align="center">Mode</th>
                    <th align="center">Duration</th>
                    <th align="center">Price</th>
                    <th align="center">Scheduled Date</th>
                    <th align="center">Status</th>
                    <th align="center">Link Status</th>

                    <th align="center">Solution Submitted</th>
                    <th align="center">Assign Intern</th>
                    <th align="center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showShimmer ? (
                    <td colspan="9">
                      <Shimmer width={"100%"} height={40} />
                    </td>
                  ) : (
                    testSeriesData &&
                    testSeriesData?.map((row, i) => (
                      <RenderSingleTestSeriesListingRow
                        updateTestSeriesAtIndex={updateTestSeriesAtIndex}
                        row={row}
                        index={i}
                        deleteCallback={deleteCallback}
                        allInterns={allInterns}
                        catid={catId}
                      />
                    ))
                  )}
                </tbody>
              </table>
              <br />
              <div>
                {offset == 0 ? null : !showLoader ? (
                  <button
                    aria-label="delete"
                    onClick={() => setOffset(offset - 1)}
                    className="btn btn-dark mr-1"
                  >
                    Previous
                  </button>
                ) : null}

                {isLast ? null : !showLoader ? (
                  <button
                    aria-label="delete"
                    onClick={() => setOffset(offset + 1)}
                    className="btn btn-primary mr-1"
                  >
                    Next
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        size="lg"
        show={isAddModalVisible}
        onHide={() => setIsAddModalVisible(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ zIndex: 10000 }}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Add Test Series
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Free</Form.Label>
                <input
                  type="checkbox"
                  className="form-control"
                  value={addSeriesData["free"]}
                  checked={addSeriesData["free"]}
                  name={"free"}
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "free", value: !addSeriesData["free"] },
                    })
                  }
                />
              </Form.Group>

              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Only Original Paper</Form.Label>
                <input
                  type="checkbox"
                  className="form-control"
                  value={addSeriesData["onlyOriginalPaper"]}
                  checked={addSeriesData["onlyOriginalPaper"]}
                  name={"onlyOriginalPaper"}
                  onChange={(e) =>
                    handleInputChange({
                      target: {
                        name: "onlyOriginalPaper",
                        value: !addSeriesData["onlyOriginalPaper"],
                      },
                    })
                  }
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  onChange={handleInputChange}
                  value={addSeriesData["title"]}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Time Duration(min)</Form.Label>
                <Form.Control
                  type="text"
                  name="duration"
                  onChange={handleInputChange}
                  value={addSeriesData["duration"]}
                  required
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Max Score</Form.Label>
                <Form.Control
                  type="text"
                  name="maxScore"
                  onChange={handleInputChange}
                  value={addSeriesData["maxScore"]}
                  required
                />
              </Form.Group>

              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Select Release Date and Time</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="scheduledReleaseDateTime"
                  onChange={handleInputChange}
                  value={addSeriesData["scheduledReleaseDateTime"]}
                  required
                />
                <p className="text-white bg-warning py-2 px-3 mt-3">
                  Please select older date if you dont want to add date and
                  time!
                </p>
              </Form.Group>
            </Row>

            {!addSeriesData["onlyOriginalPaper"] && (
              <Row>
                <Form.Group as={Col} md="6" className="position-relative">
                  <Form.Label>Mode</Form.Label>
                  <select
                    name="mode"
                    class="custom-select"
                    id="validationCustom04"
                    required
                    onChange={handleInputChange}
                  >
                    <option selected={true}>Select Mode</option>
                    <option
                      name="mode"
                      value={"PRACTICE"}
                      selected={mode == "Practice" ? true : false}
                    >
                      Practice
                    </option>
                    <option
                      name="mode"
                      value={"EXAM"}
                      selected={mode == "Exam" ? true : false}
                    >
                      Exam
                    </option>
                  </select>
                </Form.Group>
                <Form.Group as={Col} md="6" className="position-relative">
                  <Form.Label>Section Time Shared</Form.Label>
                  <select
                    name="sectionTimeSharedFlag"
                    class="custom-select"
                    id="validationCustom04"
                    required
                    onChange={handleInputChange}
                  >
                    <option selected={true}>Select</option>
                    <option
                      name="sectionTimeSharedFlag"
                      value={true}
                      selected={isSectionTimeShared ? true : false}
                    >
                      Yes
                    </option>
                    <option
                      name="sectionTimeSharedFlag"
                      value={false}
                      selected={isSectionTimeShared ? false : true}
                    >
                      No
                    </option>
                  </select>
                </Form.Group>
              </Row>
            )}

            {/* <Row>
                                <Form.Group
                                    as={Col}
                                    md="12"
                                    className="position-relative"
                                >
                                    <Form.Label>Languages</Form.Label>
                                    <Select name="languages" class="custom-select" options={languageOptionList} id="validationCustom04" required placeholder="Select Languages" value={selectedLanguages} isMulti onChange={handleLanguageSelect}/>
                                </Form.Group>
                            </Row> */}

            <Row>
              {addSeriesData["onlyOriginalPaper"] ? (
                <Form.Group as={Col} md="6" className="position-relative">
                  <Form.Label>Upload</Form.Label>
                  <input
                    className="form-control"
                    type="file"
                    ref={(ref) => (fileRef = ref)}
                    onChange={(e) => {
                      fileOnChange(e);
                    }}
                  />
                </Form.Group>
              ) : null}

              {!addSeriesData["free"] ? (
                <Form.Group as={Col} md="6" className="position-relative">
                  <Form.Label>Price</Form.Label>
                  <Form.Control
                    type="text"
                    name="price"
                    onChange={handleInputChange}
                    value={addSeriesData["price"]}
                    required
                  />
                </Form.Group>
              ) : null}
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setIsAddModalVisible(false)}
            style={{
              backgroundColor: theme.greyColor,
              color: theme.primaryColor,
            }}
          >
            Close
          </Button>
          <Button
            type="submit"
            variant="primary"
            style={{
              backgroundColor: theme.darkPurpleColor,
              marginLeft: 10,
              color: theme.primaryColor,
            }}
            onClick={() =>
              window.confirm("Are You Sure You Want To Add?")
                ? addTestSeriesData()
                : console.log("no")
            }
          >
            {loadingAddSeries ? (
              <ClipLoader
                color={theme.primaryColor}
                loading={loadingAddSeries}
              />
            ) : (
              "Add"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Snackbar
        open={isSnackBarShow}
        onClose={(e) => closeSnack(e)}
        TransitionComponent="TransitionUp"
        message={SnackBarMessage}
      />
    </div>
  );
};

export default TestSeriesListing;
